<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >设备名称/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >网关名称/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.gatewayName"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属用户/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.username"
                  placeholder="请输入所属用户名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >手机号码 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.phone"
                  placeholder="请输入"
                  clearable
                  maxlength="11"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属分组/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.groupName"
                  placeholder="请输入分组名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >所属房间/ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.houseName"
                  placeholder="请输入网关名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >升级用户 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.nickname"
                  placeholder="请输入网关名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >固件名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.firmwareName"
                  placeholder="请输入网关名称/ID"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>

            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >升级时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              style="margin-bottom: 10px"
              class="marginLeft10"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
          </div>
        </div>
      </template>
      <template slot="productType" slot-scope="{ row }">
        <div>
          {{
            row.productType == 1 ? "网关" : row.productType == 2 ? "断路器" : ""
          }}
        </div>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import { upgradeRecordList } from "@/api/upgrade/record";
import dayjs from "dayjs";
import { EClosing, MClosing, OClosing } from "@/enums/beCurrent/EBeCurrent";
import Echarts from "@/components/echarts/echartsFunc";

export default {
  name: "index",
  components: {
    Echarts,
  },
  data() {
    return {
      EClosing: EClosing,
      MClosing: MClosing,
      OClosing: OClosing,
      searchData: {
        title: "",
        createTime: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menu: false,
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        column: [
          {
            label: "产品类型",
            prop: "productType",
          },
          {
            label: "网关ID",
            prop: "gatewayId",
          },
          {
            label: "断路器ID",
            prop: "deviceId",
          },
          {
            label: "所属用户",
            prop: "nickname",
          },
          {
            label: "手机号",
            prop: "phone",
          },
          {
            label: "所属分组",
            prop: "groupName",
          },
          {
            label: "所属房间",
            prop: "gatewayName",
          },
          {
            label: "升级人",
            prop: "upgradeNickname",
          },
          {
            label: "固件名称",
            prop: "firmwareName",
          },
          {
            label: "升级时间",
            prop: "createTime",
          },
        ],
      },
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      upgradeRecordList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {};
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },

    //关闭
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}
.box_content {
  padding: 0 30px;
}
.box_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 30px;
  cursor: pointer;
}
.flex_echarts {
  display: flex;
  background: #373b47;
  padding: 0 15px;
}
.title_left {
  width: 5%;
  padding: 15px 0;
}
.left_name {
  height: 110px;
  line-height: 110px;
  color: #ffffff;
}
.echarts_left {
  width: 95%;
}
.fault_box {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.fault_box_label {
  margin-right: 10px;
}
</style>
